const general = {
  edit: 'ویرایش',
  cancel: 'لغو',
  view: 'نمایش',
  back: 'بازگشت',
  selectAndBack: 'انتخاب و بازگشت',
  start: 'شروع',
  end: 'پایان',
  price: 'قیمت',
  discount: 'تخفیف',
  toman: 'تومان',
  company: 'شرکت',
  code: 'کد',
  free: 'رایگان',
  total: 'همه',
  yes: 'بلی',
  no: 'خیر',
  all: 'همه',
  delete: 'حذف',
  first: 'اول',
  last: 'آخر',
  category: 'دسته بندی',
  images: 'تصاویر',
  save: 'ذخیره',
  aboutMe: 'درباره من',
  share: 'منتشر کنید',
  copyRedlink: 'کپی ردلینک',
};

const exceptions = {
  exception0: 'خطای نامشخصی رخ داده است.',
  exception1: 'اطلاعات وارد شده نامعتبر می باشد.',
  exception2: 'پست الکترونیکی معتبر نمی باشد.',
  exception3: 'شما قبلا ثبت نام کرده اید.',
  exception4: 'اعتبارسنجی انجام نشد.',
  exception5: 'پسورد قبلی اشتباه وارد شده است.',
  exception6: 'خطای داخلی رخ داده است.',
  exception7: 'خطای سرور رخ داده است.',
  exception8: 'شما هم اکنون کاربر حرفه ای هستید!',
  exception9: 'خطای خارجی رخ داده است.',
  exception10: 'خطایی امنیتی رخ داده است.',
  exception11: 'صفحه ای با این نام هم اکنون موجود می باشد!',
  exception12: 'آدرس اختصاصی را قبلا استفاده کرده اید.',
  exception13: 'دسته بندی هم اکنون موجود می باشد.',
  exception14: 'صفحه ای با این نام پیدا نشد!',
  exception15: 'فرمت فایل ارسالی معتبر نمی باشد.',
  exception16: 'حجم فایل ارسالی معتبر نمی باشد.',
  exception17: 'پیاده سازی تنجام نشده است.',
  exception18: 'آدرس اینترنتی معتبر نمی باشد.',
  exception19: 'این دسته بندی در محصول یا پست استفاده شده است.',
  exception20: 'پوسته فعال قابل حذف نمی باشد.',
  exception21: 'برای این محصول سفارش ثبت شده است.',
  exception22: 'صفحه ای یافت نشد.',
  exception23: 'آدرس اختصاصی قابل انتخاب نمی باشد.',
  exception24: 'حداقل یه تب فعال باید وجود داشته باشد.',
  exception25:
    'موجودی شما جهت ساختن کارت جدید به اتمام رسیده است. لطفا مجدد موجودی کارت خود را شارژ نمایید.',
  exception26: 'کد فعالسازی اشتباه است',
  exception27: 'شماره تلفن معتبر نیست',
  exception29: 'حداقل تعداد حروف برای نام صفحه ۴ می باشد.',
};

const limitations = {
  limitation1: (minLength) =>
    `حداقل تعداد حروف برای نام صفحه در اشتراک رایگان ${minLength} حرف می باشد.`,
};

const resume = {
  education: 'تحصیلات',
  experience: 'سوابق شغلی',
  addNewEducation: 'تحصیلات جدید',
  addNewExperience: 'سابقه شغلی جدید',
  addNewSkill: 'مهارت جدید',
  newEduction: 'تحصیلات جدید',
  newExperience: 'سابقه شغلی جدید',
  newSkill: 'مهارت جدید',
  university: 'دانشگاه',
  degree: 'مدرک',
  major: 'رشته',
  start: 'شروع',
  end: 'پایان',
  date: 'زمان',
  keepYourResumeUpToDate: 'رزومه خود را بروز نگاه دارید',
  new: 'جدید',
  talkAboutYourself: 'از خودت بگو',
  bioDescription: 'خلاصه‌ای از آنچه هستید و می‌توانید برآورده سازید',
  skills: 'مهارت‌ها',
  skillsDescription: 'خلاصه‌ای از آنچه هستید و می‌توانید برآورده سازید',
  workHistory: 'سوابق شغلی',
  workHistoryDescription: 'سوابق شغلی خود را درج کنید',
  educationalHistory: 'سوابق تحصیلی',
  educationalHistoryDescription: 'سوابق تحصیلی خود را درج کنید',
  featuredProjects: 'نمونه پروژه‌ها',
  featuredProjectsDescription:
    'نمونه پروژه‌ها از گالری شما فراخوانی می‌شود و لازم است پیش از انتخاب،‌ در گالری ثبت نمایید',
  achievements: 'افتخارات',
  achievementsDescription: 'رویدادهای مهم، مدارک و ویژگی‌ها',
  contactInfo: 'اطلاعات تماس',
  contactInfoDescrption:
    'اطلاعات تماس فقط برای افراد در جستجوی کار یا پروژه نمایش داده می‌شود.',
  socialMedia: 'شبکه‌های اجتماعی',
  socialMediaDescription: 'لازم است اطلاعات را در لینک‌ها ذخیره کنید',
  jobStatus: 'وضعیت اشتغال',
  working: 'مشغول به کار',
  openToWork: 'در جستجوی کار',
  newAchievement: 'افتخار جدید',
  achievement: 'عنوان',
  competition: 'مکان',
  more: 'بیشتر',
  less: 'کمتر',
  showAll: 'مشاهده همه',
  scanToAccessMyRedlink: 'برای دسترسی به ردلینک من اسکن کنید',
};

const statistics = {
  dashboard: 'آمار',

  pageViewStat: 'وضعیت بازدید',
  todayPageView: 'بازدید امروز ',
  todayPageClick: 'کلیک‌های امروز',
  allPageView: 'کل بازدید از پیج',
  linkViewStat: 'وضعیت لینک‌ها',
  mostTodayPopularLinkView: 'بیشترین بازدید امروز',
  mostPopularLinkView: 'بیشترین بازدید کل',
  allLinkClick: 'کل بازدید',
  internalLinkClick: 'بازدید داخلی',
  externalLinkClick: 'بازدید خارجی',
  allHit: 'کلیک کل',
  publishedDate: 'تاریخ انتشار',
  todayHit: 'کلیک امروز',

  viewCount: 'تعداد بازدید',
  clickCount: 'تعداد کلیک',
  viewColor: 'بازدید',
  clickColor: 'کلیک',

  last24Hours: '۲۴ ساعت',
  last7Days: '۷ روز',
  lastMonth: '۳۰ روز',

  countries: 'کشورها',
  browsers: 'مرورگرها',
  os: 'سیستم عامل ها',
  devices: 'دستگاه‌ها',
  refers: 'مرجع ها',
  lastActivities: 'آخرین فعالیت‌ها',
};

const alerts = {
  passwordNotEqualWithConfirm: 'رمز عبورها یکسان نیستند.',
  changePasswordSuccess: 'رمز عبور با موفقیت تغییر کرد',
  addYourFirstLink: 'اولین لینک خودتو بساز و با دوستات به اشتراک بزار!',
  copiedInClipboard: 'در کلیپ برد کپی شد.',
  deleteConfirmMessage: 'آیا از حذف این مورد اطمینان دارید؟',
};

const ads = {
  adsItem1: `هنوز حرفه‌ای نیستی؟! با پرداخت تنها ۵۰۰‌هزار تومان از امکانات کامل ردلینک، حرفه‌ای برخوردار شوید. گالری، فروشگاه و رزومه‌ساز ردلینک`,
  adsItem1Action: 'حرفه‌ای شو',
  adsItem2: `اینستاگرام ردلینک را دنبال کنید. تا از آخرین ویژگی‌ها و تغییرات جدید مطلع شوید و فرصت‌های تکرار نشدنی را از دست ندهید.`,
  adsItem2Action: 'مشاهده',
  adsItem3: `ردلینک خود را در بیوی اینستاگرام، توییتر و سایر شبکه‌های اجتماعی منتشر کنید و در اختیار دوستان قرار دهید`,
  adsItem3Action: 'مطالعه',
  adsItem4: `اینستاگرام ردلینک را دنبال کنید و با معرفی دوستان خود، یکی از برندگان خوش‌شانس Xiaomi Mi-band 5 باشید.`,
  adsItem4Action: 'مشاهده',
};

export const fa = {
  ...general,
  ...alerts,
  ...exceptions,
  ...limitations,
  ...resume,
  ...statistics,
  ...ads,

  messengers: 'پیام‌رسان‌ها',
  contactWays: 'راه‌های ارتباطی',
  podcasts: 'پادکست‌ها',
  profile: 'پروفایل',
  links: 'لینک‌ها',
  templates: 'افزودن',
  shop: 'فروشگاه',
  gallery: 'گالری',
  resume: 'رزومه',
  theme: 'پوسته',
  orders: 'سفارشات',
  dashboardCaption: 'پروفایل',
  profileCaption: 'پروفایل',
  linkCaption: 'لینک',
  shopCaption: 'فروشگاه',
  galleryCaption: 'گالری',
  resumeCaption: 'رزومه',
  themeCaption: 'پوسته',
  orderCaption: 'سفارشات',
  notSelected: 'انتخاب کنید ...',
  moneyPostfix: 'تومان',
  addToCard: 'اضافه کردن به سبد خرید',
  notAvailble: 'موجود نیست',
  cases: 'مورد',
  reviewShoppingList: 'تکمیل سفارش',
  redlinkInstagram: 'اینستاگرام ردلینک',
  instagram: 'اینستاگرام',
  social: 'شبکه های اجتماعی',
  virgool: 'ویرگول',
  blog: 'وبلاگ',
  name: 'نام',
  bio: 'بیوگرافی',
  email: 'پست الکترونیکی',
  phoneNumber: 'شماره تلفن',
  address: 'آدرس',
  avatarImage: 'تصویر کاربری',
  avatarImageDescription:
    'تصویر حداکثر ۵۱۲x۵۱۲ / بهتر است ابعاد تصویر بیشتر از ۴۴۴ نباشد.',
  setting: 'تنظیمات',
  yourLink: 'آدرس ردلینک (لینک اختصاصی)',
  changePassword: 'تغییر رمز عبور',
  newPassword: 'رمز عبور جدید',
  confirmPassword: 'تکرار رمز عبور',
  oldPassword: 'رمز عبور قبلی',
  addNewLink: 'افزودن لینک',
  addSeparator: 'افزدون سرفصل',
  totalHit: 'کلیک',
  newLink: 'افزودن لینک جدید',
  title: 'عنوان',
  passwordManagement: 'مدیریت پسورد',
  signOut: 'خروج از حساب کاربری',
  addPage: 'افزودن اکانت',
  url: 'آدرس اینترنتی',
  shortLink: 'آدرس اختصاصی',
  shortLinkDescription:
    'این لینک معرف شماست که می‌توانید در بیوی اینستاگرام و سایر شبکه‌های اجتماعی منتشر کنید.',
  add: 'ثبت',
  products: 'محصولات',
  addNewProduct: 'محصول جدید',
  categories: 'دسته‌بندی‌ها',
  pages: 'کارت ها',
  deactivePages: 'آرشیو شده',
  deactivePagesDescription:
    'با حرفه‌ای کردن کارت‌ها می‌توانید آنها فعال و ویرایش کنید.',
  enterPage: 'مشاهده و ویرایش',
  renewPage: 'تمدید کارت',
  purchaseNewPage: 'ایجاد کارت حرفه‌ای',
  purchaseNewPageDescription:
    'می‌توانید برای یک یا چند کارت به زبان فارسی یا انگلیسی با تمام دسترسی‌ها ایجاد کنید. اگر می‌خواهید صفحه دومی برای خود یا بیزینس خود ایجاد کنید می‌توانید از این ویژگی ردلینک استفاده کنید.',
  newCardPlaceHolder: '- کارت حرفه‌ای -',
  pay: 'پرداخت',
  addNewPage: 'افزودن ردلینک',
  addNewPageDescription:
    'می‌توانید یک کارت با زبان جدید و تمام دسترسی‌ها ایجاد کنید',
  newPageName: 'آیدی ردلینک (لینک اختصاصی)',
  pageLanguage: 'زبان پنل',
  newPageNameDescription:
    'این لینک معرف شماست که می‌توانید در بیوی اینستاگرام و سایر شبکه‌های اجتماعی منتشر کنید.',
  categoriesGuideLine1: 'شما می توانید یکی از دسته بندی‌ها را انتخاب کنید.',
  categoriesGuideLine2: 'مثل: گرافیک، طراحی محصول، تصویرسازی و ...',
  linksGuideLine1: 'شما می‌توانید یک یا چند لینک به تصویر اختصاص دهید.',
  linksGuideLine2: 'مثلا لینک مشاهده در سایر سرویس ها',
  linksGuideLine3: 'لینک‌های دانلود در سایزهای مختلف',
  addNewCategory: 'افزودن‌ دسته‌بندی',
  categoryTitle: 'عنوان‌ دسته‌بندی',
  withoutCategory: 'بدون دسته‌بندی',
  newProduct: 'محصول جدید',
  newCategory: 'دسته بندی جدید',
  description: 'توضیحات',
  newPost: 'پست جدید',
  position: 'عنوان شغلی',

  posts: 'پست ها',
  addNewPost: 'پست جدید',
  chooseYourTheme: 'انتخاب پوسته',
  makeYourSpecialTheme: 'ساخت پوسته اختصاصی',

  showSocialMedia: 'نمایش شبکه‌های اجتماعی',
  showSocialMediaDescription: '(۵شبکه اجتماعی از لینک‌ها)',
  contactInfoProfileDescription: '(شماره موبایل، ایمیل،آدرس)',

  newTheme: 'پوسته جدید',
  login: 'ورود',
  register: 'ثبت نام',
  continueWithGoogle: 'ورود از طریق گوگل',
  password: 'رمز عبور',
  forgetYourPassword: 'رمز عبور خود را فراموش کرده‌ام!',
  upgrade: 'برای استفاده از  امکانات بیشتر حرفه‌ای شو!',
  freePlan: '- رایگان -',
  proPlan: '- حرفه ای -',
  bePro: 'حرفه ای باش!',
  unlockTheOptions: 'حسابتو ارتقا بده و بدرخش!',
  from: 'از ',
  visit: ' مشاهده کنید',
  annually: 'سالانه',
  annually2: 'پرداخت سالانه',
  tomanPostfix: 'تومان',
  tomanPostfixSummary: 'ت',
  monthlyPrefix: 'معادل ماهانه',
  unlockPlan: 'ارتقا',
  upgradePlan: 'ارتقای پلن',
  status: 'وضعیت',
  items: 'مورد',
  reserved: 'رزرو شده',
  preview: 'پیش نمایش',
  orderDetail: 'جزییات سفارش',
  linkDisplay: 'لینک نمایش،‌ مشاهده یا دانلود اثر',
  shortLinkSharePost: 'لینک کوتاه برای اشتراک‌گذاری پست',
  shortLinkShare: 'لینک کوتاه برای اشتراک‌گذاری',
  profileInfo: 'اطلاعات پروفایل',
  titleNameOrCompany: 'عنوان  (نام و نام خانوادگی / نام مجموعه یا شرکت)',
  contactInfo: 'اطلاعات تماس',
  orderStatusPackaging: 'بسته بندی',
  orderStatusDelivery: 'تحویل',
  orderStatusNew: 'جدید',
  orderStatusDone: 'اتمام',
  orderStatusCancel: 'لغو',
  notExist: 'وارد نشده است',
  default: 'فعال',
  selectLinkLogo: 'آیکون',
  addYourFirstProduct: 'اولین محصول فروشگاهت رو بساز و فروش رو شروع کن!',
  addYourFirstPost: 'اولین پستت را ثبت کن و با بقیه به اشتراک بزار!',
  isAvailable: 'موجود است؟',
  noOrdersExist: 'هیچ سفارشی موجود نمی باشد.',
  setAsDefault: 'انتخاب پوسته اصلی',
  defaultTheme: 'پوسته اصلی',
  proPlanSimple: 'حرفه ای',
  proPlanExpireDaysPostfix: 'روز باقی‌مانده',
  watchTutorials: 'آموزش ببینید!',
  productBasket: 'سبد خرید',
  purchasePage: 'خرید کارت',
  card: 'کارت',
  totalPrice: 'جمع کل',
  submitOrder: 'ثبت درخواست خرید',
  contact: 'اطلاعات تماس',
  newOrderSuccess:
    'درخواست شما با موفقیت ثبت شد. فروشنده در اولین فرصت براساس اطلاعات تماس، با شما در ارتباط خواهد بود.',
  contactTip:
    'از صحیح بودن اطلاعات تماس خود اطمینان حاصل کنید. فروشنده براساس این اطلاعات با شما در تماس خواهد بود.',
  solutions: 'راهکار‌ها',
  services: 'خدمات',
  weblog: 'وبلاگ‌(آموزش)',
  priceAndPlans: 'قیمت‌ و پلن‌ها',
  support: 'پشتیبانی',
  redLinkSolutions: 'راهکارهای ردلینک',
  redLink: 'REDlink',
  solutionsEn: 'solutions',

  selectDefaultTab: 'انتخاب برگه ورود',
  selectDefaultTabDescription: `شما می‌تونید تعیین کنید با زدن ردلینک شما، کدام برگه در ابتدا نمایش داده شود.
  بصورت معمول صفحه پروفایل تنظیم شده اما ممکن است برا شما لینک‌ها، فروشگاه، گالری یا رزومه مهمتر باشد.`,
  visibleTabs: 'نمایش برگه‌ها',
  visibleTabsDescription: `به قابلیت‌های مختلفی دسترسی دارید که هریک در قالب یک برگه نمایش داده می‌شود. شما می‌توانید نمایش برگه‌هایی که نیاز ندارید را غیرفعال کنید.`,
  dontHaveAccount: 'اکانت ندارید؟',
  registerFromHere: 'از اینجا ثبت‌نام کنید',
  haveAccount: 'اکانت دارید؟',
  loginFromHere: 'از اینجا وارد شوید',
  logout: 'خروج',

  shopPlanDescription: 'تنها در نسخه حرفه‌ای می‌توانید فروشگاه خود را بسازید',
  galleryPlanDescription: 'تنها در نسخه حرفه‌ای می‌توانید گالری خود را بسازید',
  resumePlanDescription: 'تنها در نسخه حرفه‌ای می‌توانید رزومه خود را بسازید',
  linksPlanDescription: 'این قابلیت به رایگان قابل استفاده است',
  profilePlanDescription: `در نسخه رایگان به همراه لینک‌ها در یک صفحه می باشد 
در نسخه حرفه‌ای، لوگوی ردلینک‌ حذف می‌شود.`,
  themePlanDescription: 'این قابلیت به رایگان قابل استفاده است',

  reports: 'گزارش ها',
  users: 'کاربران',
  pro: 'حرفه ای',
  basic: 'پایه',

  account: 'اکانت',
  tags: 'تگ‌ها',
  tagDescription: '(نمایش داده نمی‌شود اما با آن قابل جستجو هستید)',
  showQRcode: 'نمایش QRcode',
  registerDate: 'تاریخ ثبت نام',
  expireDate: 'تاریخ اتمام اعتبار',
  accountType: 'نوع حساب',
  actions: 'عملیات',

  usersCount: 'تعداد کل کاربران',
  proUsersCount: 'تعداد کل کاربران حرفه ای',
  income: 'کل درآمد',
  todayIncome: 'درآمد امروز',
  reload: 'بروزرسانی',
  usersRegister: 'ثبت‌نام کاربران',
  saleReport: 'نمودار فروش',
  linksReport: 'آمار لینک‌ها',
  shopReport: 'آمار فروشگاه',
  galleryReport: 'آمار گالری',
  resumeReport: 'آمار رزومه',
  daily: 'روزانه',
  monthly: 'ماهانه',
  yearly: 'سالانه',
  proAccount: 'اکانت حرفه ای',
  basicAccount: 'اکانت رایگان',
  linksCount: 'تعداد کل لینک‌ها',
  activeLinksCount: 'تعداد لینک‌های فعال',
  linksClickCount: 'تعداد کلیک‌ها بر روی لینک‌ها',
  avgLinksClickCount: 'میانگین کلیک بر روی هر لینک',
  avgLinksPerUser: 'میانگین لینک به ازای هر کاربر',
  topTen: 'برترین ها',
  productCount: 'تعداد کل محصولات',
  activeProductCount: 'تعداد محصولات فعال',
  ordersCount: 'تعداد کل سفارش ها',
  avgOrdersPerShop: 'میانگین سفارش به ازای هر فروشگاه',
  avgOrdersPerProduct: 'میانگین سفارش به ازای هر محصول',
  avgProductsPerUser: 'میانگین محصولات به ازای هر کاربر',
  categoryCount: 'تعداد دسته بندی',
  avgCategoryPerShop: 'میانگین دسته بندی به ازای هر فروشگاه',
  avgProductPerCategory: 'میانگین مجصول در هر دسته بندی',
  postCount: 'تعداد کل پست ها',
  activePostCount: 'تعداد پست های فعال',
  postsClickCount: 'تعداد کلیک ها بر روی پست ها',
  avgClickPrePost: 'میانگین کلیک بر روی هر پست',
  avgPostPerUser: 'میانگین پست به ازای هر کاربر',
  avgCategoryPerGallery: 'میانگین دسته بندی به ازای هر گالری',
  avgPostPerGallery: 'میانگین پست در هر دسته بندی',
  pageName: 'آدرس اختصاصی',
  addNewUser: 'افزودن کاربر جدید',
  deepSearch: 'جستجوی پیشرفته',
  filter: 'فیلتر',
  removeFilter: 'حذف فیلتر',
  totalOf: 'کل',
  isPro: 'پلن حرفه ای؟',
  newUser: 'کاربر جدید',

  usingRedlink: 'استفاده از ردلینک',
  shareDescriptionLine1: 'ساخت رد لینک به تنهایی مهم نیست.',
  shareDescriptionLine2: 'لینک خود را در شبکه‌های اجتماعی به اشتراک بگذارید.',
  shareDescriptionLine3:
    'شما همچنین می توانید تصویر پروفایل خود را در شبکه های اجتماعی به اشتراک بگذارید.',

  goResume: 'مشاهده رزومه',

  primaryButtonColorsTitle: 'دکمه',
  backgroundColorsTitle: 'رنگ زمینه',
  coverColorsTitle: 'رنگ کاور',
  textColorsTitle: 'رنگ نوشتار',
  withGradiantOption: 'طیف‌دار (رنگ پس‌زمینه+رنگ کاور)',
  primaryColor: 'رنگ دکمه اصلی',
  saparatorColor: 'رنگ خطوط (جداکننده)',
  titleColor: 'عنوان',
  subtitleColor: 'زیرعنوان',
  descriptionColor: 'توضیحات',
  coverColor: 'رنگ کاور',
  coverTextColor: 'نوشتار کاور',
  backgroundColor: 'رنگ پس‌زمینه',
  cardColor: 'رنگ کارت‌ها',

  enterPhoneNumber: 'شماره تلفن خود را وارد کنید',
  getPhoneVerificationCode: 'دریافت کد فعالسازی',
  enterPhoneVerificationCode: 'کد فعالسازی خود را وارد کنید',
  sentVerificationCode: 'کد فعالسازی برای شماره تلفن شما ارسال شد',
  checkVerificationCode: 'فعالسازی و ورود',
  resendVerificationCode: 'ارسال مجدد کد فعالسازی',

  basicLimitationHintDescription:
    'تغییر این قسمت تنها در نسخه حرفه ای امکان پذیر می باشد.',

  planPageDescription:
    'ردلینک رایگانه و میتونی بصورت آماتور استفاده کنی اما اگر امکانات کامل نیاز داری! باید حرفه‌ای باشی :)',

  planItem1Prefix: 'ردلینک شخصی از',
  planItem1Content: '۴ حرف',

  planItem2Prefix: 'حذف محدودیت',
  planItem2Content: '۱۰ لینک',
  planItem2Postfix: 'رایگان',

  planItem3Prefix: 'حذف محدودیت',
  planItem3Content: '۵ پست',
  planItem3Postfix: 'برای گالری',

  planItem4Prefix: 'حذف محدودیت',
  planItem4Content: '۵ آیتم',
  planItem4Postfix: 'برای فروشگاه',

  planItem5Prefix: 'امکان',
  planItem5Content: 'شخصی‌سازی پوسته',

  planItem6Prefix: 'امکان',
  planItem6Content: 'شخصی‌سازی لینک',
  planItem6Postfix: 'در لینک‌ها، گالری‌ها و محصولات فروشگاه',

  planItem7Prefix: 'حذف محدودیت',
  planItem7Content: '۱ تصویر',
  planItem7Postfix: 'برای گالری و فروشگاه',

  planItem8Prefix: 'نمایش',
  planItem8Content: 'آمار حرفه‌ای و جامع',

  planItem9Prefix: 'حذف',
  planItem9Content: 'تبلیغات',

  planItem10Prefix: 'نمایش در صفحه اول و سئوی گوگل',

  commingSoon: 'به زودی',

  addShopContact: 'اطلاعات تماس فروشگاه',

  shopContactAddresses: 'آدرس',
  shopContactPhones: 'اطلاعات تماس',
  shopContactMessengers: 'پیام‌رسان‌ها',

  shopContact: {
    address: 'آدرس',
    telphone: 'تلفن ثابت',
    cellphone: 'تلفن همراه',
    email: 'پست الکترونیکی',
    telegram: 'Telegram',
    whatsapp: 'Whatsapp',
  },

  setupPageTitle: 'ایجاد ردلینک',
  continue: 'ثبت و ادامه',

  setupPageLanguageTitle: 'قدم اول',
  setupPageLanguageDescription: 'زبان پنل را انتخاب کنید.',

  setupPageNameTitle: 'قدم دوم',
  setupPageNameDescription:
    'ردلینک، لینک یکتایی است که در اختیار همه می‌گذارید و معرف شماست.',
  setupPageNameHints: `
- حداقل ۶ کاراکتر
- می‌توانید از حروف انگلیسی، عدد و کاراکتر استفاده کنید.
- تا ۷۲ ساعت بعد از انتخاب امکان تغییر نیست.
  `,
  setupPageFullnameTitle: 'قدم سوم',
  setupPageFullnameDescription:
    'عنوان می‌تواند نام شما یا کسب‌وکار شما باشد که به همگان نمایش داده می‌شود',

  setupPageAvatarTitle: 'قدم چهارم',
  setupPageAvatarDescription: 'تصویر صفحه خود را انتخاب کنید.',
  setupPageAvatarHints: `
- حداکثر ۱ مگابایت
- حداکثر ابعاد ۵۱۲ در ۵۱۲
  `,

  setupPageTagsTitle: 'قدم پایانی',
  setupPageTagsDescription: 'شغل یا علاقمندی خود را مشخص کنید.',

  startPage: 'شروع ردلینک!',
};
